import { HttpError } from './HttpError';

const DEFAULT_ERROR_MESSAGE = 'Произошла ошибка';
const SERVER_ERROR_MESSAGE = 'Сервис временно недоступен. Повторите попытку позже.';
const NETWORK_ERROR_MESSAGE = 'Не удалось связаться с сервером. Проверьте подключение к интернету и повторите попытку.';

type TApiErrorBody = {
  message?: unknown;
  errors?: unknown;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const getFirstFieldError = (errors: unknown): string | undefined => {
  if (!isRecord(errors)) return undefined;

  return Object.values(errors)
    .flat()
    .find((message): message is string => typeof message === 'string' && message.length > 0);
};

/**
 * Возвращает текст ошибки запроса для показа пользователю: для 4xx — ошибку поля или message из ответа бэкенда,
 * для 5xx и сетевых сбоев — общее сообщение без технических деталей.
 */
export function getApiError(error: unknown): string {
  if (error instanceof HttpError) {
    if (error.status >= 500) return SERVER_ERROR_MESSAGE;

    const body: TApiErrorBody = isRecord(error.data) ? error.data : {};
    const fieldError = getFirstFieldError(body.errors);

    if (fieldError) return fieldError;
    if (typeof body.message === 'string' && body.message) return body.message;

    return DEFAULT_ERROR_MESSAGE;
  }

  if (error instanceof TypeError) return NETWORK_ERROR_MESSAGE;
  if (error instanceof Error && error.message) return error.message;

  return DEFAULT_ERROR_MESSAGE;
}
